import styled from 'styled-components';

export const Wrapper = styled.div`
  .title {
    font-size: 2.5rem;
    font-weight: bold;
    margin-bottom: 30px;
  }
  .buttons {
    display: flex;
    gap: 20px;
    justify-content: flex-end;
  }

`
